import React from "react";

import "./styles.css";

const MARK_SRC = "/assets/logo/sayagie-mark.png";

const Loader = ({ className, label = "Loading" }) => {
  return (
    <div
      className={`loader-sinpper-container ${className || ""}`}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <span className="brand-loader">
        <span className="brand-loader-halo" aria-hidden="true" />
        <span className="brand-loader-ring" aria-hidden="true" />
        <img className="brand-loader-mark" src={MARK_SRC} alt="" aria-hidden="true" />
      </span>
    </div>
  );
};

export default Loader;
